export default __webpack_public_path__ + "static/media/logo_negativo.d5dbae67.png";